import { useCallback, useEffect, useState } from "react";
import { getCJWManageHistory } from "../../API/CJWManageHistoryApi";
import { getCJWDIUploadHistory } from "../../API/CJWDIUploadHistoryApi";

export const useUploadHistory = (isDIMode = false) => {
    const [uploadHistory, setUploadHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const fetchUploadHistory = useCallback( async () => {
        try{
            const data = isDIMode ? await getCJWDIUploadHistory() : await getCJWManageHistory();
            setUploadHistory(data || []);
        }catch (error) {
            console.error("Error fetching upload history:", error);
        } finally {
            setLoading(false);
        }
    }, [isDIMode]);

    const fetchFilterUploads = useCallback( async (params) => {
        try{
            let data;
            if (isDIMode) {
                data = await getCJWDIUploadHistory();
            } else if (params) {
                data = await getCJWManageHistory(params);
            }
            return data;
        }catch (error) {
            console.error("Error fetching upload history:", error);
        } finally {
            setLoading(false);
        }
    }, [isDIMode]);

    useEffect(() => {
        fetchUploadHistory();
    }, [fetchUploadHistory]);

    return {
        fetchUploadHistory,
        fetchFilterUploads,
        uploadHistory,
        page,
        setPage,
        loading
    };
};
